import { render, staticRenderFns } from "./AddressSection.vue?vue&type=template&id=3f7444f7&scoped=true"
import script from "./AddressSection.vue?vue&type=script&lang=js"
export * from "./AddressSection.vue?vue&type=script&lang=js"
import style0 from "./AddressSection.vue?vue&type=style&index=0&id=3f7444f7&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f7444f7",
  null
  
)

export default component.exports